module.exports = __webpack_public_path__ + "static/img/request-demo.7223dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/request-demo.png
// module id = DhPN
// module chunks = 0